<template>
	<div class="main">
		<div v-for="item in businessList" :key="item.id" class="business">
			<div class="businessImg" :style="'background: url('+baseImgUrl+item.img+')center no-repeat;'"></div>
			<div class="intro">
				<div>
					<div class="introTit">{{item.titEn}}</div>
					<div class="introDes">{{item.introEn}}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "Business",
	data() {
		return {
			baseImgUrl: process.env.VUE_APP_IMGURL,
			businessList: []
		}
	},
	mounted() {
		this.$api.get('about/getBusiness').then(res => {
			this.businessList = res;
		});
	}
}
</script>

<style scoped>
.main{ font-family: 'SiYuan-ExtraLight', sans-serif; }
.business, .businessImg, .intro, .introTit, .introDes{ transition: all 0.2s linear; }
.businessImg{ animation: fadeInLeft; animation-duration: 1s; }
.intro{ animation: fadeInRight; animation-duration: 1s; }
@media (max-width: 569px){
	.main{ width: 100%; display: flex; flex-wrap: wrap; justify-content: space-between; padding-top: 12px; }
	.business{ width: 100%; height: fit-content; margin-top: 18px; background: rgba(0, 0, 0, 0.7); }
	.businessImg{ width: 100%; height: 300px; background-size: cover !important; }
	.intro{ color: #ffffff; display: flex; align-items: center; justify-content: center; text-align: center; }
	.introTit{ font-size: 16px; font-family: 'SiYuan-Normal', sans-serif; margin: 10px 0; }
	.introDes{ white-space: pre-wrap; margin: 10px 0 10px 0; font-size: 12px; }
	.business:hover{ background: rgba(0, 0, 0, 0.6); }
}
@media (min-width: 570px) and (max-width: 726px){
	.main{ width: 100%; display: flex; flex-wrap: wrap; justify-content: space-between; padding-top: 17px; }
	.business{ width: 100%; height: fit-content; margin-top: 13px; display: flex; flex-wrap: nowrap; justify-content: space-between; background: rgba(0, 0, 0, 0.7); }
	.businessImg{ min-width: 300px; max-width: 300px; height: 220px; background-size: cover !important; }
	.intro{ width: 100%; color: #ffffff; display: flex; align-items: center; justify-content: center; text-align: center; }
	.introTit{ font-size: 16px; font-family: 'SiYuan-Normal', sans-serif; }
	.introDes{ white-space: pre-wrap; margin-top: 30px; font-size: 12px; }
	.business:hover{ background: rgba(0, 0, 0, 0.6); }
}
@media (min-width: 726px) and (max-width: 998px){
	.main{ width: 100%; display: flex; flex-wrap: wrap; justify-content: space-between; padding-top: 17px; }
	.business{ width: 100%; height: fit-content; margin-top: 13px; display: flex; flex-wrap: nowrap; justify-content: space-between; background: rgba(0, 0, 0, 0.7); }
	.businessImg{ min-width: 380px; max-width: 380px; height: 290px; background-size: cover !important; }
	.intro{ width: 100%; color: #ffffff; display: flex; align-items: center; justify-content: center; text-align: center; }
	.introTit{ font-size: 19px; font-family: 'SiYuan-Normal', sans-serif; }
	.introDes{ white-space: pre-wrap; margin-top: 50px; font-size: 13px; }
	.business:hover{ background: rgba(0, 0, 0, 0.6); }
}
@media (min-width: 999px) and (max-width: 1251px){
	.main{ width: 100%; display: flex; flex-wrap: wrap; justify-content: space-between; padding-top: 17px; }
	.business{ width: 100%; height: fit-content; margin-top: 13px; display: flex; flex-wrap: nowrap; justify-content: space-between; background: rgba(0, 0, 0, 0.7); }
	.businessImg{ min-width: 436px; max-width: 436px; height: 327px; background-size: cover !important; }
	.intro{ width: 100%; color: #ffffff; display: flex; align-items: center; justify-content: center; text-align: center; }
	.introTit{ font-size: 24px; font-family: 'SiYuan-Normal', sans-serif; }
	.introDes{ white-space: pre-wrap; margin-top: 50px; font-size: 14px; }
	.business:hover{ background: rgba(0, 0, 0, 0.6); }
}
@media (min-width: 1252px) and (max-width: 1530px){
	.main{ width: 100%; display: flex; flex-wrap: wrap; justify-content: space-between; padding-top: 17px; }
	.business{ width: 49.5%; height: fit-content; margin-top: 13px; display: flex; flex-wrap: nowrap; justify-content: space-between; background: rgba(0, 0, 0, 0.7); }
	.businessImg{ min-width: 280px; max-width: 280px; height: 240px; background-size: cover !important; }
	.intro{ width: 100%; color: #ffffff; display: flex; align-items: center; justify-content: center; text-align: center; }
	.introTit{ font-size: 16px; font-family: 'SiYuan-Normal', sans-serif; }
	.introDes{ white-space: pre-wrap; margin-top: 50px; font-size: 12px; }
	.business:hover{ background: rgba(0, 0, 0, 0.6); }
}
@media (min-width: 1530px) and (max-width: 1845px){
	.main{ width: 100%; display: flex; flex-wrap: wrap; justify-content: space-between; padding-top: 17px; }
	.business{ width: 49.5%; height: fit-content; margin-top: 13px; display: flex; flex-wrap: nowrap; justify-content: space-between; background: rgba(0, 0, 0, 0.7); }
	.businessImg{ min-width: 360px; max-width: 360px; height: 290px; }
	.intro{ width: 100%; color: #ffffff; display: flex; align-items: center; justify-content: center; text-align: center; }
	.introTit{ font-size: 17px; font-family: 'SiYuan-Normal', sans-serif; }
	.introDes{ white-space: pre-wrap; margin-top: 50px; font-size: 13px; }
	.business:hover{ background: rgba(0, 0, 0, 0.6); }
}
@media (min-width: 1846px) and (max-width: 2201px){
	.main{ width: 100%; display: flex; flex-wrap: wrap; justify-content: space-between; }
	.business{ width: 49%; height: fit-content; margin-top: 30px; display: flex; flex-wrap: nowrap; justify-content: space-between; background: rgba(0, 0, 0, 0.7); }
	.businessImg{ min-width: 420px; max-width: 420px; height: 327px; }
	.intro{ width: 100%; color: #ffffff; display: flex; align-items: center; justify-content: center; text-align: center; }
	.introTit{ font-size: 18px; font-family: 'SiYuan-Normal', sans-serif; }
	.introDes{ white-space: pre-wrap; margin-top: 50px; font-size: 14px; }
	.business:hover{ background: rgba(0, 0, 0, 0.6); }
}
@media (min-width: 2202px){
	.main{ width: 100%; display: flex; flex-wrap: wrap; justify-content: space-between; }
	.business{ width: 49%; height: fit-content; margin-top: 30px; display: flex; flex-wrap: nowrap; justify-content: space-between; background: rgba(0, 0, 0, 0.7); }
	.businessImg{ min-width: 436px; max-width: 436px; height: 327px; }
	.intro{ width: 100%; color: #ffffff; display: flex; align-items: center; justify-content: center; text-align: center; }
	.introTit{ font-size: 25px; font-family: 'SiYuan-Normal', sans-serif; }
	.introDes{ white-space: pre-wrap; margin-top: 50px; font-size: 17px; }
	.business:hover{ background: rgba(0, 0, 0, 0.6); }
}
</style>